import { createRouter } from '../Router.mjs';

const { RouterProvider: ScimRouterProvider, Router: ScimRouter, useRouterController: useScimRouterController} = createRouter();

export { ScimRouter, ScimRouterProvider, useScimRouterController };
//# sourceMappingURL=SCIMRouter.mjs.map
